import React, { useState } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { trackOrderApi } from "../utils/api";
import { ClipLoader } from "react-spinners";
import { format, parseISO } from "date-fns";
import ProductImage from "./ProductImage";
// import { useJitsu } from "@jitsu/react";

const formatMoney = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount)
    ? amount.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : value;
};

function OrderBox({
  order,
  settings,
  setOrderDetailsActive,
  setOrderDetails,
  setOrdersLoader,
}) {
  // const { track } = useJitsu();
  const trackOrder = () => {
    // track("clicked_on_order");
    setOrdersLoader(true);
    trackOrderApi(order.order_id, settings.merchant.id).then((resp) => {
      setOrdersLoader(false);
      if (!resp.data.data.show_not_found_error) {
        const trackingOrder = resp.data.data.order;
        setOrderDetailsActive(true);
        setOrderDetails({
          ...trackingOrder,
          order_items: order.order_items || trackingOrder.order_items || [],
        });
      }
    });
  };

  const [openRmsIframe, setOpenRmsIframe] = useState(false);
  const [returnLoader, setReturnLoader] = useState(false);

  window.addEventListener("message", (event) => {
    if (event.data.topic === "RMS") {
      if (event.data.message === "close_rms") {
        setOpenRmsIframe(false);
        document.querySelector("body").classList.remove("overflow-hidden");
      }
    }
  });

  const showReturnButton = order.order_items.every(
    (item) => item.exchange_eligible || item.refund_eligible
  );

  return (
    <article className="px-4 py-4 my-3 bg-white rounded-2xl border border-[#EAEAEB] shadow-[0_4px_16px_rgba(21,31,50,0.04)]">
      <div className="cursor-pointer" onClick={() => trackOrder()}>
        <div className="flex items-start gap-2">
          <div className="min-w-0">
            <p className="text-[10px] font-medium uppercase tracking-wide text-[#858A93]">
              Order
            </p>
            <div className="mt-0.5 flex items-center gap-2">
              <p className="text-sm font-semibold text-[#151F32]">
                {order.order_name || `#${order.order_number}`}
              </p>
              {order.fulfillment_status &&
                order.fulfillment_status !== null && (
                  <p
                    className="text-[11px] font-medium px-2 py-1 rounded-full"
                    style={{
                      color: order.fulfillment_status
                        .toLowerCase()
                        .includes("delivered")
                        ? "#16AC37"
                        : settings["--site-widget-primary-color"],
                      background: order.fulfillment_status
                        .toLowerCase()
                        .includes("delivered")
                        ? "#E8F7EB"
                        : settings["--site-widget-primary-color-50"],
                    }}
                  >
                    {order.fulfillment_status
                      .toLowerCase()
                      .includes("delivered")
                      ? "Delivered"
                      : order.fulfillment_status}
                  </p>
                )}
              {order.is_cancelled && (
                <p className="text-[11px] font-medium px-2 py-1 rounded-full bg-[#fff5f8] text-[#f1416c]">
                  Cancelled
                </p>
              )}
              {order.is_rto && (
                <p className="text-[11px] font-medium px-2 py-1 rounded-full bg-[#fff5f8] text-[#f1416c]">
                  RTO
                </p>
              )}
            </div>
          </div>
          <RiArrowRightSLine
            className="ml-auto mt-1 text-xl font-bold"
            color={`${settings["--site-widget-primary-color"]}`}
          />
        </div>
        {((order.delivery_date && order.delivery_date !== null) ||
          order.order_created_at) && (
          <div className="text-[11px] text-[#6F7580] mt-2">
            {format(
              parseISO(
                order.delivery_date && order.delivery_date !== null
                  ? order.delivery_date
                  : order.order_created_at
              ),
              "dd MMM yyyy"
            )}{" "}
            • {order.order_items.length}{" "}
            {order.order_items.length > 1 ? "items" : "item"}
          </div>
        )}

        <div className="mt-4 space-y-3">
          {order.order_items.slice(0, 2).map((orderItem) => {
            const variantOrSku =
              orderItem.variant_name || orderItem.sku || orderItem.product_sku;
            return (
              <div
                className="flex items-center gap-3 rounded-xl border border-[#EAEAEB] p-2"
                key={
                  orderItem.line_item_id ||
                  orderItem.order_item_id ||
                  orderItem.order_id
                }
              >
                <ProductImage
                  src={orderItem.image_url}
                  alt={orderItem.product_title}
                  size="shipment"
                />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-[#151F32]">
                    {orderItem.product_title}
                  </p>
                  <p className="mt-1 flex items-center gap-1 text-[11px] text-[#858A93]">
                    <span
                      style={{ maxWidth: "120px" }}
                      className="truncate"
                    >
                      {variantOrSku}
                    </span>
                    <span aria-hidden="true">•</span>
                    <span>Qty {orderItem.quantity}</span>
                  </p>
                  {orderItem.product_price != null && (
                    <p className="mt-1 text-xs font-semibold text-[#151F32]">
                      ₹{formatMoney(orderItem.product_price)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
          <div className="flex items-center">
            {order.order_items.length > 2 && (
              <div>
                <p className="text-[11px] font-medium text-[#6F7580]">
                  +{order.order_items.length - 2} more items
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="rounded-xl bg-[#F7F7F8] p-3">
        {Number(order.total_discounts) > 0 && (
          <div className="mb-3 rounded-lg bg-[#E8F7EB] px-3 py-2 text-[#137C2C]">
            <div className="flex items-center justify-between text-xs font-medium">
              <p>Coupon discount</p>
              <p>-₹{formatMoney(order.total_discounts)}</p>
            </div>
            <p className="mt-0.5 text-[10px] font-medium">
              You saved ₹{formatMoney(order.total_discounts)}
            </p>
          </div>
        )}
        <div className="flex items-center justify-between text-xs text-[#6F7580]">
          <p>Delivery fee</p>
          <p className="font-medium text-[#424A59]">
            {Number(order.total_shipping_price) > 0
              ? `₹${formatMoney(order.total_shipping_price)}`
              : "Free"}
          </p>
        </div>
        <div className="mt-3 flex items-end justify-between border-t border-[#DFE1E5] pt-3">
          <div>
            <p className="text-[10px] font-medium uppercase tracking-wide text-[#858A93]">
              Order total
            </p>
            <p className="mt-0.5 text-[11px] text-[#6F7580]">
              {order.is_cod ? "Cash on delivery" : "Prepaid"}
            </p>
          </div>
          <p className="text-base font-bold text-[#151F32]">
            ₹{formatMoney(order.total_order_price)}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-between w-full mb-2 mt-4">
        {Number(settings.merchant.id) !== 2126 && ((!order.is_cancelled && !order.is_rto && showReturnButton) || settings.merchant.id === 1597) && (
          <div className="w-full">
            <button
              onClick={() => {
                // track("clicked_on_returns_button");
                setReturnLoader(true);
                if(settings.merchant.id === 1597) {
                  window.open(`https://jockey.clickpost.in/en/returns?order_id=${order.order_id}&mobile=${order.user_phone_number}&app_only=true`, "_blank");
                } else {
                  setOpenRmsIframe(true);
                  document.querySelector("body").classList.add("overflow-hidden");
                }
              }}
              target="_blank"
              rel="noreferrer"
              className="text-xs justify-center w-full rounded flex p-2 items-center"
              style={{
                border: `1px solid ${settings["--site-widget-primary-color"]}`,
                color: settings["--site-widget-primary-color"],
              }}
            >
              Returns / Exchange
              {returnLoader ? (
                <ClipLoader
                  color={`${settings["--site-widget-primary-color"]}`}
                  cssOverride={{
                    height: "14px",
                    width: "14px",
                    marginLeft: "10px",
                  }}
                />
              ) : (
                <MdOutlineKeyboardArrowRight className="text-lg" />
              )}
            </button>
          </div>
        )}
        <div>
          {openRmsIframe && (
            <div>
              <div className="overlay" />
              <iframe
                className="site-widget-responsive-width fixed bottom-0 left-0"
                style={{
                  height: "90vh",
                  width: "100%",
                  maxWidth: "420px",
                  zIndex: 99999,
                  borderRadius: "10px",
                }}
                title="rmsIframe"
                src={order.return_exchange_url}
                onLoad={() => {
                  setReturnLoader(false);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </article>
  );
}

export default OrderBox;
